import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { AuthModal } from '../components/AuthModal'
import { useAuthStore } from '../stores/auth'
import { Sparkles, Brain, Zap, Film, Palette, Eye } from 'lucide-react'

export const AuthPage: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [showModal, setShowModal] = useState(true)
  const { isAuthenticated, checkAuth } = useAuthStore()

  const from = location.state?.from?.pathname || '/'

  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  useEffect(() => {
    if (isAuthenticated) {
      navigate(from, { replace: true })
    }
  }, [isAuthenticated, navigate, from])

  const handleCloseModal = () => {
    setShowModal(false)
    navigate('/', { replace: true })
  }

  return (
    <div className="min-h-screen bg-[#0d1117]">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-cyan-500/10 rounded-full"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-500/10 rounded-full"></div>
      </div>

      <div className="relative z-10 flex items-center justify-center min-h-screen p-4">
        <div className="w-full max-w-4xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            {/* 左侧：功能介绍 */}
            <div className="text-center lg:text-left">
              <div className="mb-8">
                <div className="flex items-center justify-center lg:justify-start mb-4">
                  <div className="bg-gradient-to-r from-cyan-500 to-blue-500 p-3 rounded-full">
                    <Brain className="w-8 h-8 text-white" />
                  </div>
                  <h1 className="ml-3 text-2xl font-bold text-white">
                    Keycore AI Studio
                  </h1>
                </div>
                <p className="text-gray-400 text-lg">
                  从灵感到图像、视频、语音，一站式 AI 创作平台
                </p>
              </div>

              {/* 功能特性 */}
              <div className="space-y-4 mb-8">
                <div className="flex items-center justify-center lg:justify-start">
                  <div className="bg-cyan-900/30 p-2 rounded-full mr-3">
                    <Sparkles className="w-5 h-5 text-cyan-400" />
                  </div>
                  <span className="text-gray-300">AI 图像生成</span>
                </div>
                <div className="flex items-center justify-center lg:justify-start">
                  <div className="bg-blue-900/30 p-2 rounded-full mr-3">
                    <Zap className="w-5 h-5 text-blue-400" />
                  </div>
                  <span className="text-gray-300">语音合成</span>
                </div>
                <div className="flex items-center justify-center lg:justify-start">
                  <div className="bg-purple-900/30 p-2 rounded-full mr-3">
                    <Palette className="w-5 h-5 text-purple-400" />
                  </div>
                  <span className="text-gray-300">PromptCraft 提示词工坊</span>
                </div>
                <div className="flex items-center justify-center lg:justify-start">
                  <div className="bg-orange-900/30 p-2 rounded-full mr-3">
                    <Film className="w-5 h-5 text-orange-400" />
                  </div>
                  <span className="text-gray-300">Director Studio 导演工作台</span>
                </div>
                <div className="flex items-center justify-center lg:justify-start">
                  <div className="bg-green-900/30 p-2 rounded-full mr-3">
                    <Eye className="w-5 h-5 text-green-400" />
                  </div>
                  <span className="text-gray-300">Vision 图像理解</span>
                </div>
              </div>

              {/* 平台优势 */}
              <div className="bg-[#161b22] border border-cyan-900/30 rounded-lg p-6">
                <h3 className="font-semibold text-white mb-3">平台优势</h3>
                <ul className="text-sm text-gray-400 space-y-2">
                  <li>• 全球边缘节点加速，生成响应快人一步</li>
                  <li>• 用户数据完全隔离，隐私安全有保障</li>
                  <li>• 从文字到图像、视频、语音的完整创作链路</li>
                  <li>• 专业级提示词工程，轻松驾驭 AI 出图</li>
                </ul>
              </div>
            </div>

            {/* 右侧：登录引导 */}
            <div className="hidden lg:block">
              <div className="bg-[#161b22] border border-cyan-900/30 rounded-lg p-8 text-center">
                <h2 className="text-xl font-semibold text-white mb-4">
                  欢迎回来
                </h2>
                <p className="text-gray-400 mb-6">
                  登录您的账户，开始 AI 创作之旅。
                </p>
                <p className="text-xs text-gray-500">
                  如需开通账户，请联系管理员。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AuthModal
        isOpen={showModal}
        onClose={handleCloseModal}
      />
    </div>
  )
}
